import {https,httpsFile} from './http.js';

export function onorder(matnr,company){
    return httpsFile().get(`/eket/${matnr}?company=${company}`);
}